import * as React from 'react';
import {LOAN_APPLICATION, LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import Button from '../../../../../common/components/Button';
import {ThanksProps} from '../../../../types/mx/creditoReal/components';
import {pushDataLayer} from '../../../../../common/utils/GTMUtils';
import {DATA_LAYER} from '../../../../../common/constants/LabelConstants';
import MotorfyIcon from '../../../../../common/components/MotorfyIcon';

class ThanksStepView extends React.Component<ThanksProps, {}> {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        setTimeout(() => pushDataLayer(DATA_LAYER.SEND_QUOTE_TURBO_CASH), 200);
    }

    render() {
        return (
            <div className="container">
                <div className="logo-inside-wizard">
                    <MotorfyIcon color="" customClass="navbar-brand-img-lg"/>
                </div>
                <div className="row">
                    <div className="col-md-8 offset-md-2">
                        <div className="row mb-5 mt-3">
                            <div className="col text-center">
                                <img src={AssetsManager('/assets/images/common/success-icon.svg')}/>
                            </div>
                        </div>
                        <div className="row mb-3 mt-3">
                            <div className="col text-center">
                                <h3 className="text-raleway text-secondary-lighten-1">
                                    {LOAN_APPLICATION.TITLE_SENT}
                                </h3>
                            </div>
                        </div>
                        <div className="row p-none mb-3">
                            <div className="col text-center">
                                {LOAN_APPLICATION.SUCCESS_TEXT_TURBO_CASH}
                            </div>
                        </div>
                        <div className="row p-none mb-3">
                            <div className="col text-center">
                                {LOAN_APPLICATION_MX.FINISHED_CONTACT_TURBO_CASH}
                            </div>
                        </div>
                        <div className="row p-none">
                            <div className="col d-flex justify-content-center">
                                <Button onPress={this.props.onPressContinue} text={LOAN_APPLICATION.LOAN_CONTINUE}
                                        customClass="px-5"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ThanksStepView;